import {IMuWidget} from "./IMuWidget";
import {stringify} from "json5";

export class AccountSelector extends IMuWidget {
	public searchCallback : (term : string, resolve: (res : AccountSelectorItem[]) => void) => void;

	private lastKeyPress: Date;

	public searchAfterSec : number = 1;

	public minTermLength : number = 3;

	override muFetchData(): string[] {
		return this.muGetChildWidgets<AccountSelectorItemSelected>("lSelected")
			.map(isw => isw.getId());
	}

	public cTerm_keypress() {
		this.lastKeyPress = new Date();
		// console.count("keypress");
		setTimeout(() => {
			// console.count("keypress on timer");
			const term = (this.ui.cTerm as HTMLInputElement).value.trim();
			if (term.length < this.minTermLength) return;
			const now = new Date();
			const diff = (now.getTime() - this.lastKeyPress.getTime()) / 1000;
			if (diff > this.searchAfterSec) {
				// console.count("loading");
				this.searchCallback(term, items => {
					this.muBindData({ searchResults: items });
				});
				this.lastKeyPress = new Date();
			}
		}, (this.searchAfterSec + 0.1) * 1000)
	}

	public addSelected(item: AccountSelectorItem) {
		this.muWidgetFromTemplate("itemSelected", "lSelected").muBindData(item);
	}

	public cleanSearch_click() {
		this.ui.cTerm.value = "";
		this.muBindData({ searchResults: [] });
	}
}

export type AccountSelectorItem = {
	name : string,
	id : number
}

export class AccountSelectorItemSelected extends IMuWidget {
	public name_click() {
		this.muRemoveSelf();
	}

	public getId() : string {
		return this.muFetchData().id;
	}
}

export class AccountSelectorItemSearched extends IMuWidget {
	public name_click() {
		(this.muParent as AccountSelector).addSelected(this.muFetchData() as AccountSelectorItem);
		this.muRemoveSelf();
	}
}